import {makeStyles} from '@material-ui/core/styles'
import GroupCreationFormCard1 from './GroupCreationFormCard1'
import GroupCreationFormCard2 from './GroupCreationFormCard2'
import GroupCreationFormCard3 from './GroupCreationFormCard3'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import {CancelButton} from '../../1elements'
import SaveButton from '../../1elements/Buttons/TextButtons/SaveButton'

const GroupFormCardSet = ({
      nameValue, setNameValue, descriptionValue, setDescriptionValue, featureSets, setFeatureSets, showError, saveHandler,
    cancelHandler, territories, setTerritories, businesses, setBusinesses, users, setUsers, owner, setOwner, edit, nameOriginal
}) => {
    const classes = useStyles()

    return (
        <>
            <GroupCreationFormCard1 nameValue={nameValue}
                                    onNameChange={setNameValue}
                                    descriptionValue={descriptionValue}
                                    onDescriptionChange={setDescriptionValue}
                                    owner={owner}
                                    setOwner={setOwner}
                                    showError={showError}
                                    nameOriginal={nameOriginal}
                                    edit={edit} />
            <GroupCreationFormCard2 selectedFeatureSets={featureSets}
                                    setSelectedFeatureSets={setFeatureSets}
                                    territories={territories}
                                    setTerritories={setTerritories}
                                    businesses={businesses}
                                    setBusinesses={setBusinesses}
                                    showError={showError}/>
            <GroupCreationFormCard3 users={users}
                                    setUsers={setUsers}
                                    owner={owner}
                                    showError={showError}/>
            <ButtonLayoutDiv className={classes.buttonDiv}>
                <CancelButton onClick={cancelHandler} />
                <SaveButton onClick={saveHandler} />
            </ButtonLayoutDiv>
        </>
    )
}

export default GroupFormCardSet

const useStyles = makeStyles({
    buttonDiv: {
        margin: '20px',
        alignSelf: 'end'
    }
})